"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _createStyled = _interopRequireWildcard(require("../../../utils/createStyled"));

var _index = _interopRequireDefault(require("../style/index"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var AnimatedDiv = _createStyled["default"].div(_templateObject(), function (props) {
  return props.animation;
});

function template() {
  var _this = this;

  var _this$state = this.state,
      active = _this$state.active,
      appearDirection = _this$state.appearDirection,
      prevActive = _this$state.prevActive,
      slideHeight = _this$state.slideHeight,
      styles = this.compileStyled(_index["default"]);
  var _this$props = this.props,
      children = _this$props.children,
      showBullets = _this$props.showBullets,
      showNavigation = _this$props.showNavigation,
      showCounter = _this$props.showCounter,
      className = _this$props.className,
      handleSwipe = _this$props.handleSwipe,
      bullets = null,
      prevArrow = null,
      nextArrow = null,
      leftSlide = null,
      rightSlide = null,
      activeAnimation = null,
      counter = null;
  children = _react["default"].Children.toArray(children);

  if (showBullets) {
    bullets = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.bulletWrapper
    }, children.map(function (child, i) {
      return _react["default"].createElement(_createStyled.Styled.Div, {
        key: i,
        styles: styles[active === i ? 'bulletActive' : 'bullet'],
        onClick: function onClick() {
          return _this.toSlide(i);
        }
      });
    }));
  }

  if (showNavigation) {
    prevArrow = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.navigationLeft,
      onClick: function onClick() {
        return _this.navigate(-1);
      }
    }, _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.navigationImgLeft
    }));
    nextArrow = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.navigationRight,
      onClick: function onClick() {
        return _this.navigate(1);
      }
    }, _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.navigationImgRight
    }));
  }

  if (showCounter) {
    var current = active + 1,
        total = children.length,
        text = _l10n["default"].translate('SLIDER_COUNTER_KEY');

    counter = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.counter
    }, current, " ", text, " ", total);
  }

  if (active !== prevActive) {
    if (appearDirection < 0) {
      activeAnimation = styles.animationToRight;
      rightSlide = _react["default"].createElement(AnimatedDiv // можно было бы очень удобно заменить на Styled.AnimatedDiv
      , {
        key: prevActive,
        styles: styles.slideWrapper,
        animation: styles.animationToRight
      }, children[prevActive]);
    } else if (appearDirection > 0) {
      activeAnimation = styles.animationToLeft;
      leftSlide = _react["default"].createElement(AnimatedDiv, {
        key: prevActive,
        styles: styles.slideWrapper,
        animation: styles.animationToLeft
      }, children[prevActive]);
    }
  }

  return _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.root,
    className: className,
    ref: this.rootRef
  }, handleSwipe ? _react["default"].createElement(_reactEventListener["default"], {
    target: "window",
    onTouchEnd: this.onTouchEnd
  }) : null, handleSwipe ? // because we need to render root before passing target ref
  _react["default"].createElement(_reactEventListener["default"], {
    target: this.root.current,
    onTouchStart: this.onTouchStart
  }) : null, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.contentWrapper
  }, prevArrow, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.wrapper,
    style: {
      height: slideHeight
    }
  }, leftSlide, _react["default"].createElement(AnimatedDiv, {
    key: active,
    styles: styles.slideWrapper,
    animation: activeAnimation,
    onAnimationEnd: this.handleAnimationEnd
  }, children[active]), rightSlide), nextArrow, counter), bullets);
}